export default "__VITE_ASSET__B4o2Ufey__"